export default [
  {
    text: "Edit",
    value: "actions",
    align: "center",
    sortable: false,
    width: 30,
  },
  {
    value: "insertedAt",
    text: "Created At",
    width: 150,
    sortable: true,
  },
  {
    value: "fullname",
    text: "Creator",
    width: 180,
    sortable: true,
  },
  {
    value: "length",
    text: "No. of Cameras",
    width: 70,
    sortable: false,
    align: "center",
    toStringFn: (item) => item["cameras"].length,
  },
  {
    value: "cameras",
    text: "Cameras",
    width: 320,
    sortable: false,
    toStringFn: (item, key) => item[key].map((camera) => camera.name).join(","),
  },
  {
    value: "recipients",
    text: "Recipients",
    width: 250,
    sortable: true,
  },
  {
    value: "provider",
    text: "Destination",
    width: 120,
    sortable: false,
  },
  {
    value: "notifyDays",
    text: "Notify Days",
    width: 120,
    sortable: true,
    align: "center",
  },
  {
    value: "notifyTime",
    width: 70,
    text: "Notify Time",
    sortable: true,
    align: "center",
  },
  {
    value: "timezone",
    text: "Timezone",
    width: 130,
    sortable: true,
  },
  {
    value: "isPaused",
    text: "Status",
    width: 70,
    sortable: true,
    align: "center",
  },
]
